// types
import { type ModuleType as Customer } from "./_definitions"
import { type State } from "../../types"

export const customerSelector = (state: State): Customer => state.customer
